import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import DefaultImg from '../../../assets/images/default_profile_img.svg';
import hamburgerIcon from '../../../assets/images/icon-menu-2.png';
import urls from '../../../routing/urls';
import Button from '../Button/Button';

import styles from './ProfileImage.module.scss';

const ProfileImage = ({ img }) => {
  const [avatar, setAvatar] = useState(img);
  const navigate = useNavigate();

  const handleClick = () => {
    if (window.innerWidth > 768) {
      localStorage.setItem('activeTab', '/account/profile');
      navigate(urls.profile);
    }
  };

  useEffect(() => {
    setAvatar(img);
  }, [img]);

  return (
    <Button variant="profile-pic" onClick={handleClick}>
      <img src={avatar} alt="profile" className={styles.profilePic} onError={() => setAvatar(DefaultImg)} />
      <img src={hamburgerIcon} alt="menu" className={styles.hamburgerIcon} />
    </Button>
  );
};

export default ProfileImage;
